import type {
  CreateEmployerAgreementPolicySelectionData,
  DeleteEmployerAgreementPolicySelectionData,
  UpdateEmployerAgreementPolicySelectionData,
} from '@festina/life-general-types/life'

export type AmendEmployerAgreementPolicySelection =
  | CreateEmployerAgreementPolicySelectionData
  | UpdateEmployerAgreementPolicySelectionData
  | DeleteEmployerAgreementPolicySelectionData

export type AmendEmployerAgreementPolicyActionOptionTypes =
  (typeof AmendEmployerAgreementPolicyKeyToType)[keyof typeof AmendEmployerAgreementPolicyKeyToType]

export const AmendEmployerAgreementPolicyKeyToType = {
  createEmployerAgreementPolicy: 'CreateEmployerAgreementPolicySelectionData',
  updateEmployerAgreementPolicy: 'UpdateEmployerAgreementPolicySelectionData',
  deleteEmployerAgreementPolicy: 'DeleteEmployerAgreementPolicySelectionData',
} as const
